'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _traits = require('../lib/traits');

var defaultTraits = _interopRequireWildcard(_traits);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TraitsProvider = function (_Component) {
  _inherits(TraitsProvider, _Component);

  function TraitsProvider() {
    _classCallCheck(this, TraitsProvider);

    return _possibleConstructorReturn(this, (TraitsProvider.__proto__ || Object.getPrototypeOf(TraitsProvider)).apply(this, arguments));
  }

  _createClass(TraitsProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        traits: (0, _merge2.default)(defaultTraits, this.props.traits)
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return TraitsProvider;
}(_react.Component);

TraitsProvider.propTypes = {
  /**
   * The children who will be provided these traits
   */
  children: _propTypes2.default.any.isRequired,

  /**
   * The traits to be added - colors, fonts, treatments, radiuses, shadows etc.
   */
  traits: _propTypes2.default.object
};

TraitsProvider.defaultProps = {
  traits: {}
};

TraitsProvider.childContextTypes = {
  traits: _propTypes2.default.object,
  defaults: _propTypes2.default.object
};

exports.default = TraitsProvider;


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/traits-provider/index.js
// module id = 873
// module chunks = 0